var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2H10.5C10.7761 2 11 2.22386 11 2.5V5H12C13.1046 5 14 5.89543 14 7V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V7C2 5.89543 2.89543 5 4 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM10 5V3H6V5H10ZM4 6C3.44772 6 3 6.44772 3 7V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V7C13 6.44772 12.5523 6 12 6H4Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default __webpack_public_path__ + "static/media/icon_briefcase.4653a91cd469fdb5094db503a4856554.svg";
export { ForwardRef as ReactComponent };